import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as GridIcon } from '../../../assets/icons/grid.svg';
import { ReactComponent as ListIcon } from '../../../assets/icons/list.svg';
import { AppDispatch } from '../../../store';
import { changeView, LayoutState } from '../../../store/layoutSlice';
import Button from '../Button';

const ViewToggler = () => {
    const dispatch = useDispatch<AppDispatch>();
    const layoutState: LayoutState = useSelector((state: any) => state.layout);

    const handleChange = () => {
        dispatch(changeView());
        // Save to localStorage immediately when user clicks
        const newView = layoutState.view === 'list' ? 'grid' : 'list';
        console.log('ViewToggler: saving view to localStorage:', newView);
        localStorage.setItem('hustleView', newView);
    };

    return (
        <Button onClick={handleChange}>
            {layoutState.view === 'list' ? <GridIcon /> : <ListIcon />}
            <span>
                {layoutState.view === 'list' ? 'Grid view' : 'List view'}
            </span>
        </Button>
    );
};

export default ViewToggler;
